import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import CategoryPage from '../pages/category/page';
import MangaDetailPage from '../pages/manga/page';
import ReadPage from '../pages/read/page';
import AboutPage from '../pages/about/page';
import ContactPage from '../pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/category/:slug',
    element: <CategoryPage />,
  },
  {
    path: '/manga/:id',
    element: <MangaDetailPage />,
  },
  {
    path: '/manga/:id/read',
    element: <ReadPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;